import { cn } from '@/utils'

export const CubeIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('stroke-gray-800', className)}
    >
      <path
        d="M0.976875 4.1051L6.79687 7.47177L12.6169 4.1051M6.79688 14.1851V7.4651M12.7969 10.1318V4.79844C12.7966 4.56462 12.7349 4.33498 12.6179 4.13255C12.5009 3.93011 12.3327 3.76201 12.1302 3.6451L7.46354 0.978437C7.26085 0.861413 7.03092 0.799805 6.79688 0.799805C6.56283 0.799805 6.3329 0.861413 6.13021 0.978437L1.46354 3.6451C1.26105 3.76201 1.09286 3.93011 0.975849 4.13255C0.858837 4.33498 0.797115 4.56462 0.796875 4.79844V10.1318C0.797115 10.3656 0.858837 10.5952 0.975849 10.7977C1.09286 11.0001 1.26105 11.1682 1.46354 11.2851L6.13021 13.9518C6.3329 14.0688 6.56283 14.1304 6.79688 14.1304C7.03092 14.1304 7.26085 14.0688 7.46354 13.9518L12.1302 11.2851C12.3327 11.1682 12.5009 11.0001 12.6179 10.7977C12.7349 10.5952 12.7966 10.3656 12.7969 10.1318Z"
        stroke="#F3F3F3"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
